<template>

    <div class="support-plan">

        <tool-container>
            <template v-slot:tabs>

                <b-tab title="Strategies">

                    <tool-container-compose-toolbar>
                    </tool-container-compose-toolbar>

                    <support-plan-step1></support-plan-step1>

                </b-tab>

                <b-tab>
                    <template v-slot:title>
                        Plan Cart
                        <b-badge variant="primary" class="support-plan__amount"
                                 v-if="docData.strategies && docData.strategies.length">
                            {{ docData.strategies.length }}
                        </b-badge>
                    </template>

                    <support-plan-cart></support-plan-cart>
                </b-tab>

                <b-tab title="Download">
                    <tool-container-preview-toolbar>
                    </tool-container-preview-toolbar>

                    <support-plan-preview></support-plan-preview>
                </b-tab>

            </template>

        </tool-container>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'
    import SupportPlanMixin from "@/providers/SupportPlanMixin"
    import ExportMixin from "@/providers/ExportMixin"

    export default Vue.extend({
        name: "SupportPlan",
        mixins: [ToolMixin, SupportPlanMixin, ExportMixin],
    })

</script>

<style lang="scss">

    @import 'sass/variables_mixins';

    .support-plan .tool__card .nav-item {
        .badge-primary {
            border-radius: 50%;
            background-color: $pink;
        }
    }

    .support-plan__amount {
        @include transform(translateY(-5px));
    }

</style>